import clsx from 'clsx'

import { AnimatedNumber } from './AnimatedNumber'
import { FootnoteLink } from './FootnoteLink'
import { useNaturalPowerRatio } from './NaturalPowerCalculatorProvider'

export function ContributionRatio() {
  const naturalPowerRatio = useNaturalPowerRatio()
  const allNaturalPower = naturalPowerRatio === 1

  return (
    <div
      className={clsx(
        'relative flex items-end justify-start w-full h-24 top-8 md:top-0 text-center select-none md:h-32 font-extralight',
        allNaturalPower && 'overflow-x-clip',
      )}>
      <div
        className={clsx(
          'relative mr-auto h-24 max-w-min',
          allNaturalPower ? 'text-xl ml-auto' : 'text-sm md:text-lg ml-0',
        )}>
        <div
          className={clsx(
            'text-[1.1em] inline-block h-7',
            allNaturalPower && 'md:text-3xl -translate-y-6 md:-translate-y-2',
          )}>
          <strong className="font-medium">
            <AnimatedNumber value={naturalPowerRatio * 100} transform={(x: number) => Math.round(x)} />
          </strong>
          %
        </div>
        <div className={clsx('md:mt-1.5', allNaturalPower && '-translate-y-4 md:translate-y-0 whitespace-nowrap')}>
          NaturalPower contribution
        </div>
      </div>

      <div
        className={clsx(
          'absolute h-24 right-0 transition-all duration-300 ease-out origin-bottom-right font-extralight text-sm md:text-lg',
          allNaturalPower ? 'opacity-0 scale-90 translate-x-4' : 'opacity-100 scale-100',
        )}>
        <strong className="font-medium text-[1.1em]">
          <AnimatedNumber value={100 - naturalPowerRatio * 100} transform={(x: number) => Math.round(x)} />
        </strong>
        %
        <br />
        <div className="md:mt-1.5">
          Traditional
          <br />
          generation sources
          <FootnoteLink id="*">
            <sup>*</sup>
          </FootnoteLink>
        </div>
      </div>
    </div>
  )
}
